import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { H2Bold } from 'components/Typography/Basic'
import { Container } from '@material-ui/core'
import styled from '@emotion/styled'
import useSWR from 'swr'
import { Link } from 'react-router-dom'
import { LinkedIn, Instagram, Telegram } from '@material-ui/icons'
import { mediaQueries } from 'devices'
import { useTranslation } from 'react-i18next'

const { REACT_APP_STRAPI_API_URL } = process.env

const TeamSection = () => {
  const { t } = useTranslation()
  const fetcher = () =>
    fetch(`${REACT_APP_STRAPI_API_URL}/api/Teams?sort[0]=id&populate=*`).then(
      response => response.json()
    )

  const { data: teamMembers, error } = useSWR(['api/team'], fetcher)
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialslide: 1
        }
      }
    ]
  }
  return (
    <section className="teams">
      <Wrapper>
        <H2Bold className="align-center">{t('c.teamtitle')}</H2Bold>
        <div className="peoples-wrapper">
          <Slider {...settings}>
            {teamMembers?.data?.map(item => (
              <TeamMember key={item.attributes.instagramlink}>
                <img
                  src={
                    REACT_APP_STRAPI_API_URL +
                    item?.attributes?.Image?.data?.attributes.url
                  }
                  alt="team-member"
                  className="member-image"
                />
                <div className="social-icons">
                  {item.attributes.linkedinlink && (
                    <Link
                      to={{ pathname: item.attributes.linkedinlink }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <LinkedIn />
                    </Link>
                  )}
                  {item.attributes.instagramlink && (
                    <Link
                      to={{ pathname: item.attributes.instagramlink }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Instagram />
                    </Link>
                  )}
                  {item.attributes.telegramlink && (
                    <Link
                      to={{ pathname: item.attributes.telegramlink }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Telegram />
                    </Link>
                  )}
                </div>
                <h5>{item.attributes.Name}</h5>
                <p>{item.attributes.Role}</p>
              </TeamMember>
            ))}
          </Slider>
        </div>
      </Wrapper>
    </section>
  )
}

export default TeamSection

const Wrapper = styled(Container)`
  .peoples-wrapper {
    margin: 0rem 20px;
    margin-top: 70px;
    margin-bottom: 200px;

    .slick-prev:before,
    .slick-next:before {
      color: #808080;
    }
  }
`

const TeamMember = styled.div`
  margin: auto;
  margin-top: 20px;
  text-align: center;

  .member-image {
    border-radius: 50%;
    height: 200px;
    width: 200px;
    margin: auto;
    margin-bottom: 20px;

    ${mediaQueries.tabport} {
      height: 150px;
      width: 150px;
    }
    ${mediaQueries.phone} {
      height: 180px;
      width: 180px;
    }
  }
  h5 {
    font-size: 24px;
    line-height: 115%;
    letter-spacing: -0.25px;
    font-family: Roboto;
    margin-top: 20px;
    margin-bottom: 0px;
  }
  p {
    margin-top: 20px;
    font-family: Roboto;
  }
  .social-icons {
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;

    .MuiSvgIcon-root {
      fill: #e7303c;
      font-size: 20px;
    }
  }
`
